import React, { Component } from 'react';
import * as d3 from 'd3';
import './milestones.css';

class ChartMilestones extends Component {
	constructor(props) {
		super(props);
		
		
		this.findMin = this.findMin.bind( this );
		this.findMax = this.findMax.bind( this );
		this.load = this.load.bind( this );
		this.draw = this.draw.bind( this );
		this.viewbox = this.viewbox.bind( this );
		this.dateFormat = this.dateFormat.bind( this );
		
		this.state = {
			"dayminus2": 0,
			"dayplus2": 0,
			"loading": true,
			"log": [],
			"milestone": {},
			"paths": {
				"activity": null,
				"arrow": {
					"bottom": null,
					"top": null
				},
				"floor": {
					"x1":0,
					"y1":0,
					"x2":0,
					"y2":0
				},
				"labels": {
					"dayminus2": {
						"textAnchor":"end",
						"x":0,
						"y":0,
						"y1": 0,
						"y2": 0
					},
					"dayplus2": {
						"textAnchor":"start",
						"x":0,
						"y":0,
						"y1": 0,
						"y2": 0
					},
					"first": {
						"textAnchor":"start",
						"x":0,
						"y":0,
						"y1": 0,
						"y2": 0
					},
					"last": {
						"textAnchor":"start",
						"x":0,
						"y":0,
						"y1": 0,
						"y2": 0
					},
					"milestone": {
						"textAnchor":"middle",
						"x":0,
						"y":0
					}
				},
				"milestone": {
					"x1":0,
					"y1":0,
					"x2":0,
					"y2":0
				},
				"popularity": null
			},
			"ready": false,
			"size": {
				"h": 200,
				"w": 400
			}
		}
	}
	
	componentDidMount() {
		if ( this.props.CollectionSlug ) {
			this.load();
		}
		this.viewbox();
		window.addEventListener( 'resize', this.viewbox, false );
	}
	
	componentDidUpdate( prevProps, prevState ) {
		if ( prevProps.CollectionSlug !== this.props.CollectionSlug ) {
			this.load();
		}
	}
	
	componentWillUnmount() {
		window.removeEventListener( 'resize', this.viewbox, false );
	}
	
	dateFormat(timestamp) {
		const d = new Date( parseFloat( timestamp ) * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2);
	}
	
	load() {
		this.props.FetchContent(
			this.props.BaseUrl + this.props.VizUrl + '/articles/number-and-popularity-by-day-by-collection?collection_slug=' + escape( this.props.CollectionSlug) + "&milestone_id=" + ( this.props.MilestoneId || '' ),
			{},
			(response) => {
				if ( typeof this.props.SetDate === 'function' ) {
					this.props.SetDate( response.generated );
				}
				this.setState( { "milestone": ( response.data.milestone || null ), "log": response.data.log, "updated": this.dateFormat( response.generated ) }, () => { this.draw(); } );
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	viewbox() {
		if ( document.querySelector('#chart-milestone-' + this.props.ChartId) !== null ) {
			var size = {
				"w": document.querySelector( '#chart-milestone-container-' + this.props.ChartId ).offsetWidth,
				"h": document.querySelector( '#chart-milestone-container-' + this.props.ChartId ).offsetHeight
			}
			this.setState( { 'size': size }, () => { if ( this.state.log && this.state.log.length > 0 ) { this.draw(); } } );
		}
	}
	
	findMax( list, key ) {
		var output = Number.MIN_VALUE;
		list.forEach(
			function(l) {
				if ( parseFloat( l[key] ) > output ) {
					output = parseFloat( l[key] );
				}
			}
		)
		return output;
	}
	
	findMin( list, key ) {
		var output = Number.MAX_VALUE;
		list.forEach(
			function(l) {
				if ( parseFloat( l[key] ) < output ) {
					output = parseFloat( l[key] );
				}
			}
		)
		return output;
	}
	
	draw() {
		let topBaseY = 10;
		let bottomBaseY = this.state.size.h - 30;
		
		let scaleX = d3.scaleLinear()
            .domain( [ this.findMin( this.state.log, 'timestamp' ), this.findMax( this.state.log, 'timestamp' ) ] )
            .range( [ 0, this.state.size.w ] );
		let scaleYAct = d3.scaleLinear()
            .domain( [ this.findMin( this.state.log, 'activity' ), this.findMax( this.state.log, 'activity' ) ] )
            .range( [ bottomBaseY, topBaseY ] );
		let scaleYPop = d3.scaleLinear()
            .domain( [ this.findMin( this.state.log, 'popularity' ), this.findMax( this.state.log, 'popularity' ) ] )
            .range( [ bottomBaseY, topBaseY ] );
		
		var points = [];
		
		this.state.log.forEach(
			function(l) {
				points.push({
					"x": scaleX( parseFloat( l.timestamp ) ),
					"yAct": scaleYAct( parseFloat( l.activity ) ),
					"yPop": scaleYPop( parseFloat( l.popularity ) )
				});
			}
		)
		
		const activityArea = d3.area()
			.x( points => points.x )
			.y1( points => points.yAct )
			.y0( points => bottomBaseY )
			.curve( d3.curveBasis );
			
		const popularityArea = d3.area()
			.x( points => points.x )
			.y1( points => points.yPop )
			.y0( points => bottomBaseY )
			.curve( d3.curveBasis );
		
		var arrowBottom = null,
			arrowTop = null,
			dayminus2 = null,
			dayplus2 = null,
			first = this.findMin( this.state.log, "timestamp" ),
			last = this.findMax( this.state.log, "timestamp" );
		
		if ( this.state.milestone ) {
			arrowTop = "M" + scaleX( this.state.milestone.timestamp ) + ",10 L" + ( scaleX( this.state.milestone.timestamp ) - 5 ) + ",0 L" + ( scaleX( this.state.milestone.timestamp ) + 5 ) + ",0Z";
			arrowBottom = "M" + scaleX( this.state.milestone.timestamp ) + "," + ( bottomBaseY - 10 ) + " L" + ( scaleX( this.state.milestone.timestamp ) - 5 ) + "," + bottomBaseY + " L" + ( scaleX( this.state.milestone.timestamp ) + 5 ) + "," + bottomBaseY + "Z";
		
			dayminus2 = parseInt( this.state.milestone.timestamp, 10 ) - (60 * 60 * 24 * 2);
			dayplus2 = parseInt( this.state.milestone.timestamp, 10 ) + (60 * 60 * 24 * 2);
		} else {
			let range = parseInt( ( parseInt( last, 10 ) - parseInt( first, 10 ) ) / 3, 10);
			dayminus2 = first + range;
			dayplus2 = last - range;
		}
		let paths = {
			"activity": activityArea( points ),
			"arrow": {
				"bottom": arrowBottom,
				"top": arrowTop
			},
			"floor": {
				"x1":0,
				"y1":bottomBaseY,
				"x2":this.state.size.w,
				"y2":bottomBaseY
			},
			"labels": {
				"dayminus2": {
					"textAnchor": ( this.state.milestone ) ? "end" : "middle",
					"x": scaleX( dayminus2 ),
					"y": this.state.size.h - 16,
					"y1": bottomBaseY,
					"y2": topBaseY
				},
				"dayplus2": {
					"textAnchor": ( this.state.milestone ) ? "start" : "middle",
					"x": scaleX( dayplus2 ),
					"y": this.state.size.h - 16,
					"y1": bottomBaseY,
					"y2": topBaseY
				},
				"first": {
					"textAnchor":"start",
					"timestamp": first,
					"x":scaleX( first ) + 1,
					"y": this.state.size.h - 4,
					"y1": bottomBaseY,
					"y2": topBaseY
				},
				"last": {
					"textAnchor":"end",
					"timestamp": last,
					"x":scaleX( last ) - 1,
					"y": this.state.size.h - 4,
					"y1": bottomBaseY,
					"y2": topBaseY
				},
				"milestone": {
					"textAnchor": "middle",
					"x": ( this.state.milestone ) ? scaleX( this.state.milestone.timestamp ) : 0,
					"y": ( this.state.milestone ) ? this.state.size.h - 16 : 0
				}
			},
			"milestone": {
				"x1": ( this.state.milestone ) ? scaleX( this.state.milestone.timestamp ) : 0,
				"y1": 0,
				"x2": ( this.state.milestone ) ? scaleX( this.state.milestone.timestamp ) : 0,
				"y2": ( this.state.milestone ) ? bottomBaseY : 0
			},
			"popularity": popularityArea( points )
		}
		this.setState( { "dayminus2": dayminus2, "dayplus2": dayplus2, "first": this.findMin( this.state.log, 'timestamp' ) , "last": this.findMax( this.state.log, 'timestamp' ), "ready": true, "paths": paths } );
		if ( typeof this.props.SetLoading === 'function' ) {
			this.props.SetLoading( false );
		}
	}
	
	render() {
			return (
				<div className="chart-milestone" id={"chart-milestone-" + this.props.ChartId}>
					<article className="chart-milestone-detail">
						<ChartMilestonesTitle Milestone={this.state.milestone ? this.state.milestone : null} />
						<div className="chart-milestone-container" id={"chart-milestone-container-" + this.props.ChartId}>
							<svg className={"chart-milestone-viz " + this.props.CollectionSlug} preserveAspectRatio="xMidYMid meet" viewBox={"0 0 " + this.state.size.w + " " + this.state.size.h}>
								<g>
									<text x="10" y="18"  textAnchor="start" className="chart-milestone-viz-label">{this.props.AddLabel ? "Storico attività per " : ""}<tspan>{this.props.Collection}</tspan></text>
									<rect x="10" y="25" width="10" height="10" className="chart-milestone-viz-legend-popularity" />
									<text x="25" y="33"  textAnchor="start" className="chart-milestone-viz-label">Popolarità</text>
									<rect x="10" y="40" width="10" height="10" className="chart-milestone-viz-legend-activity" />
									<text x="25" y="48"  textAnchor="start" className="chart-milestone-viz-label">Attività</text>
								</g>
								<g>
									<line x1={this.state.paths.labels.dayminus2.x} y1={this.state.paths.labels.dayminus2.y1} x2={this.state.paths.labels.dayminus2.x} y2={this.state.paths.labels.dayminus2.y2} className="chart-milestone-viz-line-date" />
									<line x1={this.state.paths.labels.dayminus2.x} y1={this.state.paths.labels.dayminus2.y1} x2={this.state.paths.labels.dayminus2.x} y2={this.state.paths.labels.dayminus2.y1 + 4} className="chart-milestone-viz-line-date chart-milestone-viz-line-date-solid" />
									<text x={this.state.paths.labels.dayminus2.x} y={this.state.paths.labels.dayminus2.y} textAnchor={this.state.paths.labels.dayminus2.textAnchor} className="chart-milestone-viz-label">{this.dateFormat(this.state.dayminus2)}</text>								
									
									
									<line x1={this.state.paths.labels.dayplus2.x} y1={this.state.paths.labels.dayplus2.y1} x2={this.state.paths.labels.dayplus2.x} y2={this.state.paths.labels.dayplus2.y2} className="chart-milestone-viz-line-date" />	
									<line x1={this.state.paths.labels.dayplus2.x} y1={this.state.paths.labels.dayplus2.y1} x2={this.state.paths.labels.dayplus2.x} y2={this.state.paths.labels.dayplus2.y1 + 4} className="chart-milestone-viz-line-date chart-milestone-viz-line-date-solid" />						
									<text x={this.state.paths.labels.dayplus2.x} y={this.state.paths.labels.dayplus2.y} textAnchor={this.state.paths.labels.dayplus2.textAnchor} className="chart-milestone-viz-label">{this.dateFormat(this.state.dayplus2)}</text>
									
									
									<line x1={this.state.paths.labels.first.x} y1={this.state.paths.labels.first.y1} x2={this.state.paths.labels.first.x} y2={this.state.paths.labels.first.y2} className="chart-milestone-viz-line-date" />
									<line x1={this.state.paths.labels.first.x} y1={this.state.paths.labels.first.y1} x2={this.state.paths.labels.first.x} y2={this.state.paths.labels.first.y1 + 16} className="chart-milestone-viz-line-date chart-milestone-viz-line-date-solid" />
									<text x={this.state.paths.labels.first.x} y={this.state.paths.labels.first.y} textAnchor={this.state.paths.labels.first.textAnchor} className="chart-milestone-viz-label">{this.dateFormat(this.state.paths.labels.first.timestamp)}</text>
									
									<line x1={this.state.paths.labels.last.x} y1={this.state.paths.labels.last.y1} x2={this.state.paths.labels.last.x} y2={this.state.paths.labels.last.y2} className="chart-milestone-viz-line-date" />
									<line x1={this.state.paths.labels.last.x} y1={this.state.paths.labels.last.y1} x2={this.state.paths.labels.last.x} y2={this.state.paths.labels.last.y1 + 16} className="chart-milestone-viz-line-date chart-milestone-viz-line-date-solid" />								
									<text x={this.state.paths.labels.last.x} y={this.state.paths.labels.last.y} textAnchor={this.state.paths.labels.last.textAnchor} className="chart-milestone-viz-label">{this.dateFormat(this.state.paths.labels.last.timestamp)}</text>
								</g>
								<g>
									<path d={this.state.paths.popularity} className="chart-milestone-viz-popularity" />
									<path d={this.state.paths.activity} className="chart-milestone-viz-activity" />
								</g>
								<g>	
									<line x1={this.state.paths.floor.x1} y1={this.state.paths.floor.y1} x2={this.state.paths.floor.x2} y2={this.state.paths.floor.y2} className="chart-milestone-viz-floor" />							
								</g>
								<ChartMilestonesMarker Milestone={this.state.milestone} MilestonePath={this.state.paths.milestone} Arrow={this.state.paths.arrow} Labels={this.state.paths.labels} DateFormat={this.dateFormat} />
							</svg>
						</div>
					</article>
				</div>
			);
	}
}

export default ChartMilestones;



class ChartMilestonesTitle extends Component {
	render() {
		if ( this.props.Milestone && this.props.Milestone.title ) {
			return (
				<header>
					<h1>{this.props.Milestone.title}</h1>
				</header>
			);
		} else {
			return null;
		}
	}
}

class ChartMilestonesMarker extends Component {
	render() {
		if ( this.props.Milestone ) {
			return (
				<g>
					<line x1={this.props.MilestonePath.x1} y1={this.props.MilestonePath.y1} x2={this.props.MilestonePath.x2} y2={this.props.MilestonePath.y2} className="chart-milestone-viz-milestone" />
					<path d={this.props.Arrow.top} className="chart-milestone-viz-arrow chart-milestone-viz-arrow-top" />
					<path d={this.props.Arrow.bottom} className="chart-milestone-viz-arrow chart-milestone-viz-arrow-bottom" />
					<text x={this.props.Labels.milestone.x} y={this.props.Labels.milestone.y} textAnchor={this.props.Labels.milestone.textAnchor} className="chart-milestone-viz-label chart-milestone-viz-milestone-label">{this.props.DateFormat(this.props.Milestone.timestamp)}</text>
				</g>
			);
		} else {
			return null;
		}
	}
}


// WEBPACK FOOTER //
// ./src/Elezioni/charts/milestones.js